import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild ,ElementRef} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { RfqCacheService } from '../../dashboard/rfq-cache.service';
import { FormBuilder, AbstractControl, FormArray, FormControl, FormGroup, NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SearchService } from 'src/app/views/search/search/search.service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { Page } from 'src/app/shared/models/page';
import { aboutDataType, AutoCompleteDataType, AutoCompleteSupplierProduct, Currency, quoteAttachmentType, quoteDeclineReasonType ,incoterms, offeredQuality, portData, supplierBranchData, Vessel } from 'src/app/shared/models/settings.model';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { RfqTokenAuthService } from 'src/app/shared/services/rfq-token-auth.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
// import { SupplierService } from '../../supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService} from 'src/app/views/settings/suppliers/supplier.service';
import { Supplier } from 'src/app/shared/models/supplier.model';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { QuoteService } from '../../dashboard/quote/quote.service';
import { RfqGenerateFormService } from '../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { MatSelectChange } from '@angular/material/select';
import { v4 as uuidv4 } from "uuid";
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';




import { BuyerService } from 'src/app/views/settings/buyers/buyer.service';
import { AttachmentTypes } from 'src/app/shared/common/Enums';
import { MatRadioChange } from '@angular/material/radio';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import moment from 'moment';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

interface Attachment {
  name: string;
  systemName: string;
  fileKey: string;
  s3_path: string;
}

interface Countries {
  name: string;
  code: string;
  dialcode: string;
  currency: string;
  flag:string;
}

interface Location {
  locationId: number;     
  locationName: string;   
  code: string;        
}

interface Incoterm {
  incotermId: number;      
  incotermCode: string;   
  userId: number;     
  locationDetails: Location[]; 
}

@Component({
  selector: 'app-rfq-token-quote-preview',
  templateUrl: './quote-form-preview.component.html',
  styleUrls: ['./quote-form-preview.component.css']
})


export class RfqTokenQuoteFormPreviewComponent implements OnInit{
  @ViewChild('table') table!: DatatableComponent;
  @ViewChild('pdfContent') contentToPrint!: ElementRef<HTMLDivElement>;

  rfqId!: number;
  quoteId!: number;
  userRole!: string;
  showDataForBuyer: boolean = true;
  isSaved: boolean = false;
  currentTab: string = 'preview';
  tabEnabled: boolean = false;
  lastId!: number;
  quoteStatus:any;
  paymentFormGroup!: UntypedFormGroup;
  buyerFormGroup!: UntypedFormGroup;
  firstFormGroup!: UntypedFormGroup;
  secondFormGroup!: UntypedFormGroup;
  declineFormGroup!: UntypedFormGroup;
  buyerId!: Number;
  userId!: number;

  buyerStreet:any;
  buyerCity:any;
  buyerZipCode:any;
  buyerStateCode:any;
  buyerCountry:any;

  showFreightDetails: boolean = false;
  supplierCurrencyName:string=''
  

  tabs: any[] = [
    {
      index: 0,
      label: 'LINE ITEMS',
      icon: "directions_boat",
      route: 'line-items',
    },
    {
      index: 1,
      label: 'HEADER DETAILS',
      icon: "looks",
      route: 'header',
    },
    {
      index: 2,
      label: 'PAYMENT TERMS',
      icon: "location_searching",
      route: 'payment-terms',
    },{
      index:3,
      label: 'PREVIEW',
      icon: "location_searching",
      route: 'preview',
    }
  ];

  showNotification: boolean = false;
  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';

  paymentTermsData:any[]=[]
  paymentLeadTimeId:any;
  paymentTermsId:any;
  paymenttermsconditioncolumn:any;
  paymentTermsAndConditionAttachmentUrl:any;
  paymentTermsAndConditionsSection:boolean=false;

  buyerPaymentTermsAndConditionAttachmentUrl:any;
  buyerPaymentTermsAndConditionsSection:boolean=false;

  
 

  isForm1Expand: boolean = true;
  isForm2Expand: boolean = true;
  isForm3Expand: boolean = true;
  isForm4Expand: boolean = true;
  isForm5Expand: boolean = true;
  isForm6Expand: boolean = true;
  isForm7Expand: boolean = true;
  isForm8Expand: boolean = true;

  headerAttachmentUrl:any;
  headerAttachmentSection:boolean=false;
  // paymentTermsAndConditionsSection:boolean=false;
  buyerAttachmentsSection:boolean=false;
  paymentTermsAndConditions:any;
  // paymentTermsAndConditionAttachmentUrl:any;
  buyerAttachmentUrl:string[]=[];
  currentIndex = 0;
  supplierAttachmentUrls:string[]=[];
  supplierAttachmentsSection:boolean=false;
  supplierCurrentIndex:number=0;

  incoterms:incoterms[]=[]
  offeredQualityData:offeredQuality[]=[]
  headerAttachmentType:quoteAttachmentType[]=[]
  lineItemAttachmentType:quoteAttachmentType[]=[]

  previewSection: boolean = false;
  previewDocs:any[]=[]
  currentDocIndex = 0;

  freightValues:any[]=[]

  // boundGetCurrencyAutoComplete!: (pageMeta: Page) => Observable<any>;
  boundGetCountryAutoComplete!: (pageMeta: Page) => Observable<any>;

  filterFieldCountryNameDisplayFn(_country: AutoCompleteDataType) {
    return _country ? `${_country.name}` : undefined;
  }
  searchKeyParams: string = '';

  showAddDocumentSection:boolean=false

  selectedAttachmentType!:number |null
  newfileuploaded:boolean=false;
  uploadedAttachmentsArray: any[] = []; 
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024; //10MB
  delAttachmentArr:number[] = [];
  minDate=new Date()


  declineReason:string = ''
  showDeclineConfirmationDialogue:boolean=false

  countryControl: FormControl = new FormControl();
  // countries: Countries[] = [];
  countries: any[] = [];
  filteredCountries: any[] = [];
  selectedCountries: any[] = [];
  incotermLocationList:any[]=[]

  convertedUnitCosts: any[] = [];  
  convertedTotalCosts: any[] = []; // Store converted amounts for total cost

  lineItemtableForm!: any;
  row: any = [];
  dataSource: any[] = [];
  headerData:any;
  // showDeclineConfirmationDialogue:boolean=false
  showDetailSection: boolean = false;
  isWrapDescription: boolean = false;
  
  // showAddDocumentSection: boolean = false;
  showAddCostSection: boolean = false;
  showDeclineSection: boolean = false;

  showOtherReason: boolean = false;
  showHazardousDeclaration: boolean = false;


  showConfirmationDialogue: boolean = false
  showSuccessDialogue: boolean = false
  showCloseDialogue: boolean = false;

  displayedColumns = ['position', 'partNumber', 'supplierPartNumber', 'itemDescription',
     'buyerComment', 'supplierComment', 'customsCode', 'uom', 'quantity',  'supplierUom', 'supplierQuantity', 
     'unitCost','requestedUnitCost', 'discount', 'totalCost', 'requestedTotalCost','leadTime','attachments','delete'
  ];

  groupHeadersColumns = [
  'checkboxGroup',
  'positionGroup',
  'partNumberGroup',
  'supplierPartNumberGroup',
  'itemDescriptionGroup',
  'buyerCommentGroup',
  'supplierCommentGroup',
  'customsCodeGroup',
  'attachmentsGroup',
  'uomQuantityGroup',
  'supplierUomQuantityGroup',
  'unitCostGroup',
  'discountGroup',
  'totalCostGroup',
  'leadTimeGroup',
  'deleteGroup'
];

  lineItemAttachmentTypeData:quoteAttachmentType[]=[]
  delineReasonData:quoteDeclineReasonType[]=[]

  selectedLineItemIndex!:number | null

  // declineReason!:number | null
  otherReason:string=''

  freightDescription:string=''
  freightType:string=''
  freightValue!:number |null
  addedAdditionalCost:any[]=[]

  // selectedAttachmentType!:number|null
  hazardousDeclaration!:number|null
  // newfileuploaded:boolean=false;
  // uploadedAttachmentsArray: any[] = []; 
  // acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  // maxFileSize: number = 10 * 1024 * 1024; //10MB
  

  currentdate=new Date()
  taxStatusData:any[]=[]

  tableWidth = '100%';
  dynamicColumns = [
    // { key: 'buyerComment', name: 'Buyer Comment', visible: false },
    // { key: 'supplierComment', name: 'Supplier Comment', visible: false },
    // { key: 'customsCode', name: 'Customs Code', visible: false },
    // { key: 'quantity', name: 'Requested Quantity', visible: false },
    // { key: 'uom', name: 'Requested UOM', visible: false },
    // { key: 'unitCost', name: 'Unit Cost', visible: false },
    // { key: 'discount', name: 'Discount', visible: false },
    // { key: 'totalCost', name: 'Total Cost', visible: false },
    // { key: 'leadTime', name: 'Lead Time', visible: false },
    // { key: 'supplierUom', name: 'Supplier UOM', visible: false },
    // { key: 'supplierQuantity', name: 'Supplier Quantity', visible: false },
    { key: 'attachments', name: 'Attachments', visible: false },
    { key: 'requestedUnitCost', name: 'Requested Unit Cost', visible: false },
    { key: 'requestedTotalCost', name: 'Requested Total Cost', visible: false },
    // { key: 'delete', name: 'Delete', visible: false },
  ];

  showColumn(col:{ key: string; name: string; visible: boolean }) {
    col.visible = !col.visible;
    // this.tableWidth = 'max-content';
    // this.cdr.detectChanges();
    this.table.recalculate(); 
  }

  showToggleColumns(col:any){
    col.visible = !col.visible;
    this.table.recalculate(); 

    const baseCurrency = this.headerData?.currencyId?.currencyCode || 'EUR';
    const supplierCurrency = this.supplierCurrencyName || 'EUR'; 

    this.fetchExchangeRates(baseCurrency, supplierCurrency);

  }

  // Toggle the visibility of freight details table
  toggleFreightDetails() {
    this.showFreightDetails = !this.showFreightDetails;
  }

  getColumn(key: string) {
    return this.dynamicColumns.find(c => c.key === key);
  }

  boundGetCurrencyAutoComplete!: (pageMeta: Page) => Observable<any>;
  // searchKeyParams: string = '';

  boundGetSupplierProductAutoComplete!: (pageMeta: Page) => Observable<any>;

  quoteLineItemApplicableTaxProfile  :string=''
  quoteLineItemTaxAmount :string=''
  quoteLineItemTaxType:string=''
  exchangeRatesCache: any = {}; 

  constructor(
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private SettingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private supplierService:SupplierService,
    public dialog: MatDialog,
    private ls: LocalStoreService,
    private quoteService: QuoteService,
    private RfqGenerateFormService:RfqGenerateFormService,
    private webApiService: WebApiService,
    private awsSdkService: AwsSdkService,
    private BuyerService: BuyerService,
    private fb: FormBuilder,
    private dataTransferService: DataTransferService<any>,
    private rfqTokenAuth: RfqTokenAuthService,
    private http: HttpClient
  ) {

   
    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([])
    });
  }

  async ngOnInit() {
    this.fullLoaderService.showLoader();
    const token = this.rfqTokenAuth.getToken();
    if (!token) {
      this.fullLoaderService.hideLoader();
      this.router.navigate(['/tokenLogin']);
      return;
    }
    const storedSupplierId = this.rfqTokenAuth.getSupplierId();
    this.userId = storedSupplierId ? Number(storedSupplierId) : 0;
    this.userRole = 'Suppliers';
    this.showDataForBuyer = false;

    this.boundGetCurrencyAutoComplete =
      this.getCurrencyFilterKeyDataObservable.bind(this);

      this.boundGetSupplierProductAutoComplete =
      this.getSupplierProductFilterKeyDataObservable.bind(this);
    
    this.boundGetCountryAutoComplete = this.getCountryFilterKeyDataObservable.bind(this)

    this.firstFormGroup = this._formBuilder.group({
            
      // quote details
      quoteId: [null],
      rfqId: [null],
      quoteRefNumber: [null],
      supplierRfqDetailsId:[null],
      quoteDate: [new Date()],
      priceGoodUntilDate: [new Date()],
      offeredQuality: [null],
      onTimeDeliveryOrderDate: [new Date()],
      quotedDeliveryInDays: [null],

      // incoterms details
      incoterms: [null],
      incotermLocation: [null],

      // my details
      supplierId: [null],
      supplierContactName: [''],
      supplierEmail: [null],
      supplierTelephone: [null],
      supplierMobile: [null],
      supplierCompanyEmail: [null],
      supplierCurrency: [null],

      // comment
      supplierComment: [null],
      buyerComment: [null],
      quoteHeaderAttachmentType:[null],
      quoteHeaderAttachments:[null],

      // freight forwarder
      quoteFreightForwarderId: [null],
      freightForwarderDetailsId : [null],
      freightForwarderCompanyName: [null],
      pic : [null],
      freightForwarderJobTitle : [null],
      freightForwarderEmailId : [''],
      freightForwarderPhone : [null],
      freightForwarderFax : [null],
      freightForwarderAddress : [null],
      packaging : [null],
      modeOfTransport : [null]


    });

    this.secondFormGroup = this._formBuilder.group({

      quoteLineItemHeaderId:[null],
      quoteLineItemListPriceSubtotal:[null],
      quoteLineItemDiscount:[null],
      quoteLineItemSubtotal :[null],
      quoteLineItemGeneralDiscountType :[null],
      quoteLineItemGeneralDiscountValue:[null],
      quoteLineItemFreightTotal:[null],
      quoteLineItemFreight:[null],
      quoteLineItemTotal :[null],
      supplierCurrency: [null],
    });

    this.paymentFormGroup = this._formBuilder.group({
      supplierRfqDetailsId:[null],
      paymentTermsId:[null],
      termsAndConditions:[null],
      currencyInstructions :[null],

      billingAddress:[null],
      taxStatus:[null],
      buyerTermsAndConditions :[null],
      buyerPaymentTerms :[null],

    });

    this.buyerFormGroup = this._formBuilder.group({

      billingAddress:[null],
      taxStatus:[null],
      buyerTermsAndConditions :[null],
      buyerPaymentTerms :[null],


    });

    this.incoterms =  await this.quoteService.fetchAllIncotermsByRfqToken();
    this.incotermLocationList =
      await this.SettingsService.fetchAllIncotermsBySupplierIdByRfqToken();
    console.log("incotermLocationList",this.incotermLocationList);
    if(this.incotermLocationList?.length){
      this.onIncotermSelected(this.incotermLocationList[0].incotermId)
    }


    this.offeredQualityData = await this.quoteService.fetchAllOfferedQualityByRfqToken();
    this.headerAttachmentType = await this.quoteService.fetchAllQuteAttachmentTypeByRfqToken('QuoteHeaderAttachmentType');
    this.countries = await this.SettingsService.fetchAllCountryDetailsByRfqToken();
    this.getAllpaymentTerms()



    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([]),
    });

    this.lineItemAttachmentTypeData = await this.quoteService.fetchAllQuteAttachmentTypeByRfqToken('QuoteLineItemAttachmentType');
    
    this.delineReasonData = await this.quoteService.fetchAllDeclineReasonByRfqToken();



    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['rfqId'] != '' && params['quoteId'] != '' ) {
        this.isSaved = true
        this.rfqId = params['rfqId']
        this.quoteId = params['quoteId']

        this.getQuoteDraftData()
        this.paymentFormGroup.disable(); 
      }



    })


    this.fetchRfqDetails()

    
    this.checkisTabEnabled()
    this.firstFormGroup.get('offeredQuality')?.disable();
    this.firstFormGroup.get('incoterms')?.disable();
    this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.disable();
    console.log("dataSource",this.dataSource);
    this.fullLoaderService.hideLoader();
    
  }

  getCountryFilterKeyDataObservable(pageMeta: Page): Observable<any> {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    return this.countryDataWithSearch(pageMeta.serachParam)
  }

  countryDataWithSearch(searchText: any) {
    const regex = new RegExp(searchText, 'i');
    return new Observable<any>(observer => {
      let data = JSON.parse(this.ls.getItem('countries'))
      const filteredData = data.filter((item: any) => regex.test(item.name));
      const dataResult = { rows: filteredData }
      observer.next(dataResult);
      observer.complete();
    });
  }

  onIncotermSelected(incotermId:Number): void {
      // Set the selected incotermId in the form control
      // this.incotermsFormGroup.get('incoterms')?.setValue(incotermId);
      // console.log("incotermId",this.incotermsFormGroup.get('incoterms')?.value);
      // this.firstFormGroup.get('incoterms')?.setValue(incoterm.incotermId);
      // this.firstFormGroup.patchValue({
      //     incoterms: incoterm.incotermId, // Set selected incotermId
      //     incotermLocation: incoterm.locationDetails.map((loc: Location) => loc.locationId),  
      //   });
  
      // Find the matching incoterm entry first
      const matchingIncoterm = this.incotermLocationList.find(
        (item: any) => item.incotermId === incotermId
      );
      console.log({matchingIncoterm});
      if(matchingIncoterm){
  
        // Patch the form with incotermId and extracted locationIds
        this.firstFormGroup.patchValue({
            incoterms: matchingIncoterm.incotermId,
            incotermLocation: matchingIncoterm.locationDetails.map((loc: Location) => loc.locationId),
          });
  
        this.selectedCountries = matchingIncoterm.locationDetails.map((loc: Location) => ({
            id: loc.locationId,
            name: loc.locationName
        }));
  
      }else{
        console.log("setting the selected incoterms....")
        this.firstFormGroup.get('incoterms')?.setValue(incotermId);
        this.firstFormGroup.get('incotermLocation')?.reset();
        this.selectedCountries=[];
      }
  
      console.log("incotermId",this.firstFormGroup.get('incoterms')?.value);
    }

  // async save() {

    
  //   console.log("INSIDE SAVE");
    
  //   const lineitems = this.lineItemtableForm.value.rows
  //   // Get items that are active and not in attachedProducts array
    
  //   const activeLineItems = lineitems.filter((item: { isActive: number; }) => item.isActive === 1 )
    
  
  //   if(activeLineItems.length == 0){
  //     this.snack.open('Atleast one active line item should be present.', 'OK', {
  //       duration: 3000,
  //     });
  //     return;
  //   }

   
  //   this.fullLoaderService.showLoader()
  //   // Loop through each attachment and upload to S3
  //   for (let rowIndex = 0; rowIndex < lineitems.length; rowIndex++) {
     
  //     const row = lineitems[rowIndex];
  //     let attachmentFiles:any = {} 
  //     let attachmentArray = row.attachments || [];
  //     const partNumber = row.partNumber 
  //     console.log(attachmentArray,'attachmentArray','lineitems',lineitems)
     

  //     attachmentArray = attachmentArray.filter((item: { file: any; })=>item.file)
          
  //         // generate the s3 upload content for each attachment file
  //     let uploadPath = `quotation/${this.quoteId}/${partNumber}`
      
  //     await Promise.all(attachmentArray.map(async(attachment:any,index:any)=>{
  //       if(!attachment.file){
  //             return
  //       }

  //           let fileName = attachment.file.name
  //           let fileExt = attachment.name.slice(
  //             ((attachment.name.lastIndexOf('.') - 1) >>> 0) + 2
  //           );
            
  //           let fileNameSystem = `${uuidv4()}.${fileExt}`

  //           attachment.systemName = fileNameSystem //This name denotes the fileNames for our system records
  //           let s3Location = `${uploadPath}/${fileName}`; //!this location to be verified before starting upload
      
  //           let _s3Params = {
  //             fileKey: s3Location,
  //             fileContentType: (<File>attachment.file).type,
  //           };
  //           attachment.s3Params = _s3Params
  //           attachmentFiles[attachment.file.name] = attachment.file
  //         }))

  //         // get presigned urls for all the attachments in bulk
  //         row.attachments = await this.SettingsService.getBulkAttachmentUrls(attachmentArray)

  //         row.attachments.map(async(attachment:any)=>{
  //           attachment.s3_path = this.awsSdkService.extractS3LocationFromUrl(attachment.s3_path)
  //           attachment.fileKey = attachment.s3Params.fileKey
  //         })

  //         // upload all the iamges to s3 bucket
  //         await Promise.all(row.attachments.map(async (attachment:any)=>{
  //           this.webApiService.putRequestExternalApi(attachment.s3_path, attachmentFiles[attachment.name])
  //         }))

  //   }

  //   const lineItemHeaderData = this.secondFormGroup.value
  //   console.log("lineItemHeaderData",lineItemHeaderData);
  //   // if (!this.isValidFreight()) {
  //   //   this.snack.open('Freight details are required before proceeding.', 'OK', {
  //   //     duration: 3000
  //   //   });
  //   //   this.fullLoaderService.hideLoader()
  //   //   return; 
  //   // }

  //   const lineItemTable = this.lineItemtableForm.value;
  //   console.log("lineItemTable");
  //   const params1 = {
  //     section: 'tab2',
  //     quoteStatus: 2,
  //     tabId: 1,
  //     quoteId: this.quoteId,
  //     lineItemData: lineItemHeaderData,
  //     lineItemTableData: lineItemTable

  //   };

    

  //   // console.log(this.lineItemtableForm.value,this.rfqId)
  //   if (this.quoteId && this.isSaved && this.secondFormGroup.get('quoteLineItemHeaderId')?.value != null 
  //   ) {

  //     console.log("updateQuoteAsDraft called in quoteLineItems");
  //     const result1 = await this.quoteService.updateQuoteAsDraft(params1);

  //     if (result1?.data) {
  //       console.log("result1 of updated quote draft from line items",result1.data);
  //       this.fullLoaderService.hideLoader()

  //       this.snack.open(`Line Item Data Saved`, "OK", { duration: 3000 });
  //       this.next()

  //     } else {
  //       this.fullLoaderService.hideLoader()
  //       throw new Error('Invalid response format: Expected { data: number }');
  //     }

  //   }

  //   else {
  //     console.log("saveQuotedAsDraft is called in quoteLineItems")
  //     const result1 = await this.quoteService.saveQuoteAsDraft(params1);


  //       if (result1?.data) {


  //         this.snack.open(`Line Item Data Saved`, "OK", { duration: 3000 });

  //         this.isSaved = true;
  //         this.next()


  //       } else {
  //         this.fullLoaderService.hideLoader()
  //         throw new Error('Invalid response format: Expected { data: number }');
  //       }


       


  //     }

    
  // }

//   isValidRequiredFields(): string[] {
//   const missingFields: string[] = [];

//   // Check if 'unitCost' is missing in any of the rows
//   const lineItems = this.lineItemtableForm.value.rows;
//   for (const row of lineItems) {
//     if (!row.unitCost || row.unitCost <= 0) {
//       missingFields.push(`Unit Cost for line item ${row.position}`);
//     }
//     if (!row.leadTime || row.leadTime <= 0) {
//       missingFields.push(`Lead Time for line item ${row.position}`);
//     }
//   }

//   // Check if 'offeredQuality' is missing
//   if (!this.firstFormGroup.get('offeredQuality')?.value) {
//     missingFields.push('Offered Quality');
//   }

//   return missingFields;
// }

// isValidRequiredFields(): { section: string, fields: string[] }[] {
//   const missingFields: { section: string, fields: string[] }[] = [];

//   // Check for missing fields in Tab1 (Line Items Section)
//   const lineItemMissingFields: string[] = [];
//   const lineItems = this.lineItemtableForm.value.rows;
//   lineItems.forEach((row: any) => {
//     if (!row.unitCost || row.unitCost <= 0) {
//       lineItemMissingFields.push(`Unit Cost for line item ${row.position}`);
//     }
//     if (!row.leadTime || row.leadTime <= 0) {
//       lineItemMissingFields.push(`Lead Time for line item ${row.position}`);
//     }
//   });

//   if (lineItemMissingFields.length > 0) {
//     missingFields.push({ section: 'Line Items', fields: lineItemMissingFields });
//   }

//   // Check for missing fields in Tab2 (Details Section)
//   const detailsMissingFields: string[] = [];
//   const form = this.firstFormGroup;

//   if (!form.get('offeredQuality')?.value) {
//     detailsMissingFields.push('Offered Quality');
//   }

//   if (!form.get('quotedDeliveryInDays')?.value) {
//     detailsMissingFields.push('Quoted Delivery In Days');
//   }

//   if (!form.get('priceGoodUntilDate')?.value) {
//     detailsMissingFields.push('Price Good Until Date');
//   }

//   if (detailsMissingFields.length > 0) {
//     missingFields.push({ section: 'Header Details', fields: detailsMissingFields });
//   }

//   // Check for missing fields in Tab3 (Payment Terms Section)
//   const paymentTermsMissingFields: string[] = [];
//   const paymentForm = this.paymentFormGroup;

//   if (!paymentForm.get('paymentTermsId')?.value) {
//     paymentTermsMissingFields.push('Payment Terms');
//   }

//   if (!paymentForm.get('currencyInstructions')?.value) {
//     paymentTermsMissingFields.push('Currency Instructions');
//   }

//   if (paymentTermsMissingFields.length > 0) {
//     missingFields.push({ section: 'Payment Terms', fields: paymentTermsMissingFields });
//   }

//   return missingFields;
// }



// Function that dismisses the notification
  dismissNotification() {
    this.showNotification = false;
  }

// Function to display the notification with missing fields
showMissingFieldsNotification(missingFields: { section: string, fields: string[] }[]) {
  let message = '<strong>Please fill all the missing fields before proceeding:</strong><br><br>';

  // Loop through each section and list its missing fields
  missingFields.forEach(missingField => {
    message += `<strong>${missingField.section}:</strong><br>`; // Add section name
    message += missingField.fields.map(field => `  • ${field}`).join('<br>'); // List missing fields with bullet points
    message += '<br><br>'; // Add extra spacing between sections
  });

  this.notificationMessage = message;
  this.notificationTitle = 'Missing Fields';
  this.notificationType = 'error'; // Change this to 'info' for informational notifications
  this.showNotification = true; // Display the notification
}



  // Validation logic to check for required fields
  // isValidRequiredFields(): { section: string, fields: string[] }[] {
  //   const missingFields: { section: string, fields: string[] }[] = [];

  //   // Check for missing fields in Tab1 (Line Items Section)
  //   const lineItemMissingFields: string[] = [];
  //   const lineItems = this.secondFormGroup.value;
  //   if (!lineItems.unitCost || lineItems.unitCost <= 0) {
  //     lineItemMissingFields.push('Unit Cost for line item');
  //   }
  //   if (!lineItems.leadTime || lineItems.leadTime <= 0) {
  //     lineItemMissingFields.push('Lead Time for line item');
  //   }

  //   if (lineItemMissingFields.length > 0) {
  //     missingFields.push({ section: 'Line Items', fields: lineItemMissingFields });
  //   }

  //   // Check for missing fields in Tab2 (Header Section)
  //   const headerMissingFields: string[] = [];
  //   const form = this.firstFormGroup;

  //   if (!form.get('offeredQuality')?.value) {
  //     headerMissingFields.push('Offered Quality');
  //   }

  //   if (!form.get('quotedDeliveryInDays')?.value) {
  //     headerMissingFields.push('Quoted Delivery In Days');
  //   }

  //   if (!form.get('priceGoodUntilDate')?.value) {
  //     headerMissingFields.push('Price Good Until Date');
  //   }

  //   if (headerMissingFields.length > 0) {
  //     missingFields.push({ section: 'Header Details', fields: headerMissingFields });
  //   }

  //   // Check for missing fields in Tab3 (Payment Terms Section)
  //   const paymentTermsMissingFields: string[] = [];
  //   const paymentForm = this.paymentFormGroup;

  //   if (!paymentForm.get('paymentTermsId')?.value) {
  //     paymentTermsMissingFields.push('Payment Terms');
  //   }

  //   if (!paymentForm.get('currencyInstructions')?.value) {
  //     paymentTermsMissingFields.push('Currency Instructions');
  //   }

  //   if (paymentTermsMissingFields.length > 0) {
  //     missingFields.push({ section: 'Payment Terms', fields: paymentTermsMissingFields });
  //   }

  //   // Show notification if there are missing fields
  //   if (missingFields.length > 0) {
  //     this.showMissingFieldsNotification(missingFields);
  //   }

  //   return missingFields;
  // }

  isValidRequiredFields(): { section: string, fields: string[] }[] {
  const missingFields: { section: string, fields: string[] }[] = [];

  // ✅ Check for missing fields in Tab1 (Line Items Section)
  const lineItemMissingFields: string[] = [];
  const lineItems = this.lineItemtableForm.value?.rows || [];

  lineItems.forEach((item: any, index: number) => {

    if (item.isActive === 0) {
      return;
    }

    if (!item.unitCost || item.unitCost <= 0) {
      lineItemMissingFields.push(`Unit Cost for line item #${index + 1}`);
    }
    if (!item.leadTime || item.leadTime <= 0) {
      lineItemMissingFields.push(`Lead Time for line item #${index + 1}`);
    }
  });

  
  const lineItemForm= this.secondFormGroup;

  if (!lineItemForm.get('supplierCurrency')?.value) {
    lineItemMissingFields.push('supplierCurrency');
  }

  if (lineItemMissingFields.length > 0) {
    missingFields.push({ section: 'Line Items', fields: lineItemMissingFields });
  }

  // ✅ Check for missing fields in Tab2 (Header Section)
  const headerMissingFields: string[] = [];
  const form = this.firstFormGroup;

  if (!form.get('offeredQuality')?.value) {
    headerMissingFields.push('Offered Quality');
  }

  if (!form.get('onTimeDeliveryOrderDate')?.value) {
    headerMissingFields.push('On Time Delivery Order Date');
  }

  // if (!form.get('quotedDeliveryInDays')?.value) {
  //   headerMissingFields.push('Quoted Delivery In Days');
  // }

  if (!form.get('priceGoodUntilDate')?.value) {
    headerMissingFields.push('Price Good Until Date');
  }

  if (headerMissingFields.length > 0) {
    missingFields.push({ section: 'Header Details', fields: headerMissingFields });
  }

  // ✅ Check for missing fields in Tab3 (Payment Terms Section)
  const paymentTermsMissingFields: string[] = [];
  const paymentForm = this.paymentFormGroup;

  if (!paymentForm.get('paymentTermsId')?.value) {
    paymentTermsMissingFields.push('Payment Terms');
  }

  if (!paymentForm.get('currencyInstructions')?.value) {
    paymentTermsMissingFields.push('Currency Instructions');
  }

  if (paymentTermsMissingFields.length > 0) {
    missingFields.push({ section: 'Payment Terms', fields: paymentTermsMissingFields });
  }

  // ✅ Show notification if there are missing fields
  if (missingFields.length > 0) {
    this.showMissingFieldsNotification(missingFields);
  }

  return missingFields;
}




  async save(isDraft: boolean){
    this.showConfirmationDialogue = false;
    this.showCloseDialogue = false;
  
  
  if (!isDraft) {
    const missingFields = this.isValidRequiredFields();
    if(missingFields.length>0){
      return; 
    }
    // If there are missing fields, show a snack bar message with the missing sections
    // let message = `Please fill all the missing fields before proceeding:\n`;
    // missingFields.forEach(missingField => {
    //   message += `${missingField.section}:\n`;
    //   message += missingField.fields.map(field => `  • ${field}`).join('\n');
    //   message += '\n\n';
    // });

    // // Show the message in the snack bar
    // this.snack.open(message, 'OK', {
    //   duration: 10000,  // Show the message for 10 seconds
    // });
    // Prevent submission
    // If there are missing fields, show a snack bar message with the missing sections
    // let message = '';
    //   missingFields.forEach(missingField => {
    //     message += `<strong>${missingField.section}:</strong><br>`;
    //     message += missingField.fields.map(field => `• ${field}`).join('<br>');
    //     message += '<br><br>';
    //   });

    //   // Show the message in the snack bar with HTML rendered
    //   this.snack.open(message, 'OK', {
    //     duration: 10000,  // Show the message for 10 seconds
    //     horizontalPosition: 'center',
    //     verticalPosition: 'bottom',
    //     panelClass: ['custom-snack-bar']  // Optional: For custom styling
    //   });

    //   return;
  }
    
    
      
  const dateString1 = this.firstFormGroup.value.quoteDate ? moment(this.firstFormGroup.value.quoteDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
  const dateString2 = this.firstFormGroup.value.priceGoodUntilDate ? moment(this.firstFormGroup.value.priceGoodUntilDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
  const dateString3 = this.firstFormGroup.value.onTimeDeliveryOrderDate ? moment(this.firstFormGroup.value.onTimeDeliveryOrderDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;

  
      this.firstFormGroup.patchValue({
        quoteDate: dateString1,
        priceGoodUntilDate: dateString2,
        onTimeDeliveryOrderDate: dateString3
      });


    this.fullLoaderService.showLoader()

    try {
      const params = {
        section: 'tab3',
        isDraft: isDraft,
        quoteStatus: isDraft ? 14 : 3,
        quoteId: this.quoteId,
        tabId: 3,
        paymentDetails: this.paymentFormGroup.value,
        rfqId: this.rfqId
      };

      const result = await this.quoteService.updateQuoteAsDraftByRfqToken(params);

      if (result?.data) {

        if (isDraft) {
          this.snack.open('Quotation saved as draft', 'OK', {
            duration: 2000,
          });
          this.rfqTokenAuth.clear();
          this.router.navigate(['/tokenLogin']);
        } else {
          const currencyCode =
            this.firstFormGroup.get('supplierCurrency')?.value?.currencyCode ||
            this.supplierCurrencyName ||
            this.headerData?.currencyId?.currencyCode ||
            null;

          let formdata = {
            supplierId: this.userId,
            rfqId: Number(this.rfqId),
            quoteId: Number(this.quoteId),
            buyerId: this.buyerId,
            currencyCode: currencyCode
          }

          console.log(" formdata->",formdata);
          const acknowledgmentResult = await this.quoteService.sendQuotationAcknowledgmentByRfqToken(formdata)
          console.log({acknowledgmentResult});

          this.snack.open(`Quotation submitted successfully`, "OK", { duration: 3000 });
          this.rfqTokenAuth.clear();
          this.router.navigate(['/tokenLogin']);
        }
        this.cdr.detectChanges();

      } else {
        throw new Error('Invalid response format: Expected { data: number }');
      }
    } catch (error) {
      console.error('Error submitting quotation:', error);
      this.snack.open('Error submitting quotation. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
      // if (isDraft) {
  
      //   const result = await this.quoteService.saveQuoteAsDraft(params);
  
  
      //   if (result?.data) {
  
      //     this.fullLoaderService.hideLoader()
  
      //     this.snack.open(` Quotation Saved as Draft`, "OK", { duration: 3000 });

  
      //   } else {
      //     this.fullLoaderService.hideLoader()
      //     throw new Error('Invalid response format: Expected { data: number }');
      //   }
  
      // }
  
      // else{
  
        
  
      // }
  }

  // async generateAndSendPdf(): Promise<void> {
  //       if (!this.contentToPrint?.nativeElement) {
  //         console.error('PDF content element not found!');
  //         return;
  //       }
      
  //       // Expand all forms
  //       this.isForm1Expand = true;
  //       this.isForm2Expand = true;
  //       this.isForm3Expand = true;
  //       this.isForm4Expand = true;
  //       this.isForm5Expand = true;
  //       this.isForm6Expand = true;
  //       this.isForm7Expand = true;
  //       this.isForm8Expand = true;
  //       this.isWrapDescription = true;
      
  
  //       const element = this.contentToPrint.nativeElement;
  //       const pdf = new jsPDF('p', 'mm', 'a4');
  //       const pageWidth = pdf.internal.pageSize.getWidth() - 20; // with margins
  //       const pageHeight = pdf.internal.pageSize.getHeight() - 20;
        
  
  //       // Store original styles
  //       const originalOverflow = element.style.overflow;
  //       const originalHeight = element.style.height;
        
  //       try {
  //         // Temporarily modify styles for proper capture
  //         element.style.overflow = 'visible';
  //         element.style.height = 'auto';
          
  //         // Wait for UI to update after expanding forms
  //         await new Promise(resolve => setTimeout(resolve, 500));
      
  //         // Get full content dimensions
  //         const fullHeight = element.scrollHeight;
          
  //         // Create options for html2canvas
  //         const options = {
  //           scale: 1,
  //           useCORS: true,
  //           allowTaint: true,
  //           scrollX: 0,
  //           scrollY: 0,
  //           width: element.scrollWidth,
  //           height: fullHeight,
  //           windowWidth: element.scrollWidth,
  //           windowHeight: fullHeight,
  //           logging: true
  //         };
      
  //         // Capture entire content
  //         const canvas = await html2canvas(element, options);
  
  //         const imgWidth = pageWidth;
  //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
          
  //         // Split across pages if content is taller than one page
  //         let position = 0;
          
  //         while (position < imgHeight) {
  //           const sectionHeight = Math.min(pageHeight, imgHeight - position);
            
  //           if (position > 0) {
  //             pdf.addPage();
  //           }
            
  //           // Create a new canvas for each page section
  //           const tempCanvas = document.createElement('canvas');
  //           tempCanvas.width = canvas.width;
  //           tempCanvas.height = sectionHeight * (canvas.height / imgHeight);
  //           const ctx = tempCanvas.getContext('2d');
            
  //           if (ctx) {
  //             ctx.drawImage(
  //               canvas,
  //               0, // source x
  //               position * (canvas.height / imgHeight), // source y
  //               canvas.width, // source width
  //               sectionHeight * (canvas.height / imgHeight), // source height
  //               0, // destination x
  //               0, // destination y
  //               canvas.width, // destination width
  //               sectionHeight * (canvas.height / imgHeight) // destination height
  //             );
              
  //             const imgData = tempCanvas.toDataURL('image/jpeg');
  //             pdf.addImage(
  //               imgData,
  //               'JPEG',
  //               10, // x
  //               10, // y
  //               imgWidth,
  //               sectionHeight
  //             );
  //           }
            
  //           position += sectionHeight;
  //         }
          
  //         const pdfBlob = pdf.output('blob');
  
         
  //     let s3Location = `quotation/${this.firstFormGroup.get('rfqRefNo')?.value}.pdf`
  
      
  //     let _s3Params = {
  //       fileKey: s3Location,
  //       fileContentType: pdfBlob.type || 'application/pdf',
  //     };
  
  //     await this.awsSdkService
  //       .getSignedUrlPromise(_s3Params)
  //       .then((_fileUploadLink: any) => {
  //         if (_fileUploadLink) {
  //           this.webApiService
  //             .putRequestExternalApi(_fileUploadLink, pdfBlob)
  //             .then(async (_fileUploadData: any) => {
  //               // //!Logic for saving file url in the database
  //               let filePath =
  //                 this.awsSdkService.extractS3LocationFromUrl(_fileUploadLink);
  
  //                 let formdata = {
  //                   filePath: this.awsSdkService.extractS3LocationFromUrl(_fileUploadLink),
  //                   rfqId:Number(this.rfqId)
  //                 }
                  
  //                  await this.RfqGenerateFormService.sendRfq(formdata)
  
  
  //                 await this.RfqGenerateFormService.sendRfqAcknowledgment(formdata)
  
  //             })
  //             .catch((_httpErrorResponse: HttpErrorResponse) => {
  //               console.log(
  //                 'Error while uploading file==>',
  //                 _httpErrorResponse
  //               );
  //               this.fullLoaderService.hideLoader();
  //             });
  //         }
  //       })
  //       .catch((_httpErrorResponse: HttpErrorResponse) => {
  //         console.log(
  //           'Error while generating presigned url for file==>',
  //           _httpErrorResponse
  //         );
  //         this.fullLoaderService.hideLoader();
  //       });
  
  
          
  //       } catch (error) {
  //         console.error('Error generating or sending PDF:', error);
  //         throw error; // Re-throw if you want calling code to handle it
  //       } finally {
  //         // Restore original styles
  //         element.style.overflow = originalOverflow;
  //         element.style.height = originalHeight;
  //       }
  //     }

  async submit(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true
    }
    else {
      this.showCloseDialogue = true
      this.quoteStatus=14;
      this.cdr.detectChanges();
      
    }

  }

  cancel() {
    this.showConfirmationDialogue = false
    this.showCloseDialogue = false
  }

  isValidFreight(): boolean {
    const freightField = this.secondFormGroup.get('quoteLineItemFreight');
    
    // Check if freight details are provided
    if (!freightField?.value || freightField?.value.length === 0) {
      return false; // Return false if freight details are not provided
    }

    return true; // Return true if freight details are valid
  }

  async back() {

    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['rfqId'] != '' && params['quoteId'] != '' ) {

        this.rfqId = params['rfqId']
        this.quoteId = params['quoteId']


        this.router.navigate([
          "dashboard", "quote", "create", 'payment-terms'
        ],
          {
            queryParams: { rfqId: this.rfqId, quoteId:this.quoteId }
          }
        );

    }})
    

  }
  closeLineItems(){
    this.router.navigate([
      "operations", "all-documents"
    ]
    );
  }


  toggleVisibility(section: string) {
    if (section == 'form1') {
      this.isForm1Expand = !this.isForm1Expand
    }
    else if (section == 'form2') {
      this.isForm2Expand = !this.isForm2Expand
    }
    else if (section == 'form3') {
      this.isForm3Expand = !this.isForm3Expand
    }
    else if (section == 'form4') {
      this.isForm4Expand = !this.isForm4Expand
    }
    else if (section == 'form5') {
      this.isForm5Expand = !this.isForm5Expand
    }
    else if (section == 'form6') {
      this.isForm6Expand = !this.isForm6Expand
    }
    else if (section == 'form7') {
      this.isForm7Expand = !this.isForm7Expand
    }
    else if (section == 'form8') {
      this.isForm8Expand = !this.isForm8Expand
    }
   
  }

  async next() {

    // if (this.isSaved) {
      
    //   this.activatedRoute.queryParams.subscribe(async params => {


    //     if (params['rfqId'] != '' && params['quoteId'] != '' ) {
  
    //       this.rfqId = params['rfqId']
    //       this.quoteId = params['quoteId']
  
  
    //       this.router.navigate([
    //         "dashboard", "quote", "create", 'payment-terms'
    //       ],
    //         {
    //           queryParams: { rfqId: this.rfqId, quoteId:this.quoteId }
    //         }
    //       );
  
    //   }})


    // }

    if (this.isSaved) {

      this.activatedRoute.queryParams.subscribe(async params => {

        if (params['rfqId'] != '' && params['quoteId'] != '') {

          this.rfqId = params['rfqId']
          const quoteId = this.quoteId

          this.router.navigate([
            "dashboard", "quote", "create", 'header'
          ],
            {
              queryParams: { rfqId: this.rfqId, quoteId: quoteId }
      
            }
          );

        }

      })
    }
    else{
      this.snack.open(`please save the 'Header' tab first`, "OK", { duration: 3000 });
    }
  }

  

  calculateRowValues(index: number): void {
    
    const form = this.lineItemtableForm.get('rows') as FormArray;

    const row = form.at(index);

    console.log(index, row)
    if (!row) {
      console.error(`No row found at index ${index}`);
      return;
    }

    const quantity = parseFloat(row.get('supplierQuantity')?.value || '0');
    const unitCost = parseFloat(row.get('unitCost')?.value || '0');
    const discount = parseFloat(row.get('discount')?.value || '0');

    const discountedUnitPrice = unitCost * (1 - discount / 100);
    const totalCost = quantity * discountedUnitPrice;

    row.get('discountedUnitPrice')?.setValue(discountedUnitPrice, { emitEvent: false });
    row.get('totalCost')?.setValue(totalCost, { emitEvent: false });
    
    this.calculateCostSummary()

  }


  calculateCostSummary(){
    
      let subTotalCost = 0;
      let totalDiscount = 0;
      let totalUnitCost = 0;
      let totalCost = 0;
      let totalFreightAmount = 0;
    
      const lineItemTable = this.lineItemtableForm.value;

      const row = lineItemTable.rows

      row.forEach((item: any) => {
        if (item.isActive === 1){
        
        const quantity = item.supplierQuantity || 0;
        const unitCost = item.unitCost || 0;
        const discount = item.discount  || 0;
        const discountedUnitPrice =  item.discountedUnitPrice || 0;
       
  
        const rowTotalCost = discountedUnitPrice * quantity;
        const rowDiscount = discount * quantity;
        const rowUnitCost = unitCost * quantity;

        subTotalCost += rowTotalCost;
        totalDiscount += rowDiscount;
        totalUnitCost += rowUnitCost;
        totalCost += rowTotalCost;
        }
        
    });

   
    
    if(this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.value != null ){
       
      const type = this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.value

      const genDiscount = parseFloat(this.secondFormGroup.get('quoteLineItemGeneralDiscountValue')?.value || '0');

      if(type == 'percentage' ){
        
        totalCost -= (genDiscount / 100) * totalCost;
        
      }
      else{
        totalCost = totalCost - genDiscount;
      }
    }
    // if(this.secondFormGroup.get('quoteLineItemFreightTotal')?.value != null){

    //   const type = this.secondFormGroup.get('quoteLineItemFreightTotal')?.value

    //   const freight = parseFloat(this.secondFormGroup.get('quoteLineItemFreight')?.value || '0');

    //   if(type == 'percentage' ){
    //     totalCost += (freight / 100) * totalCost;
    //   }
    //   else{
    //     totalCost = totalCost + freight;
    //   }
    //   }
    if(this.secondFormGroup.get('quoteLineItemFreight')?.value != null){

      console.log("hi")
      const freight = this.secondFormGroup.get('quoteLineItemFreight')?.value

      if(freight.length > 0){

        freight.forEach((item: { freightValue: string; freightType: string; }) => {
          
          
          const freightValue = parseFloat(item.freightValue);
        
          if (item.freightType === 'percentage') {
            totalCost += (freightValue / 100) * totalCost; // Apply percentage freight value
            totalFreightAmount += (freightValue / 100) * totalCost; 

          } else if (item.freightType === 'amount') {
            totalCost += freightValue; // Add flat freight amount
            totalFreightAmount += freightValue; 
          }
        });

      }
    
      }

      console.log(this.secondFormGroup.get('quoteLineItemFreightTotal')?.value,totalFreightAmount,'totalFreightAmount')
    
    this.secondFormGroup.get('quoteLineItemFreightTotal')?.setValue(totalFreightAmount, { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemListPriceSubtotal')?.setValue(totalUnitCost, { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemDiscount')?.setValue(totalDiscount, { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemSubtotal')?.setValue(subTotalCost, { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemTotal')?.setValue(totalCost, { emitEvent: false });

    
    
  }


  populateForm(data: any[]) {
    console.log(data)
    data.forEach(item => {
      this.addRow(item);
    });
  }
  allowOnlyLetters(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow A-Z, a-z and space
    if (
      !(charCode >= 65 && charCode <= 90) &&  // uppercase letters
      !(charCode >= 97 && charCode <= 122) && // lowercase letters
      !(charCode === 32)                      // space
    ) {
      event.preventDefault();
    }
  }

  addRow(data: any) {
    
    // const discountedUnitPrice = this.calculateDiscountedUnitPrice(data);
    // const totalCost = this.calculateTotalCost(data, discountedUnitPrice);

    const row = this._formBuilder.group({
      id: [data.id || null],
      position: [data.position || ''],
      partNumber: [data.partNumber || ''],
      supplierPartNumber: [data.supplierPartNumber || ''],
      itemDescription: [data.itemDescription || ''],
      impaId: [data.impaId || 0],
      buyerComment: [data.buyerComment || ''],
      supplierComment: [data.supplierComment || ''],
      customsCode: [data.customsCode || ''],
      attachments: [data.attachments || []],
      uom: [data.uom || ''],
      supplierUom: [data.supplierUom || ''],
      quantity: [data.quantity || 0],
      supplierQuantity: [data.supplierQuantity|| 0],
      unitCost: [data.price || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedUnitCost: [data.price || 0.00],
      discount: [data.discount || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      discountedUnitPrice: [data.discountedUnitPrice || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      totalCost: [data.totalCost || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedTotalCost:[data.totalCost || 0.00],
      isActive: [data.isActive ],
      declineReasonTypeId : [data.declineReasonTypeId || null],
      delineOtherReason:[data.delineOtherReason || ''],
      declineReasonDescription:[data.declineReasonDescription || ''],
      leadTime: [data.leadTime || 0],

      isNew: [data.isNew || 0],
      isAddedBySupplier: [data.isAddedBySupplier || 0],
      supplierProductId:  [data.supplierProductId || 0],
      addedLineItempartNumber:[data.addedLineItempartNumber || 0]

    });

    console.log(this.lineItemtableForm.get('rows'),'test 1')

    // this.setupRowListeners(row);
    this.rows.push(row); // Add the row to the FormArray

    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }


  addNewLineItem(){

    const obj = {
      position: this.dataSource.length+1,
      id: null,
      partNumber: null,
      supplierPartNumber:null,
      itemDescription: null,
      impaId: null,
      buyerComment: null,
      supplierComment: '',
      customsCode: '',
      attachments: [],
      uom: null,
      quantity: 0,
      supplierUom:null,
      supplierQuantity:0,
      unitCost: 0,
      discount: 0,
      totalCost: 0,
      isActive:1,
      isNew: 1,
      isAddedBySupplier: 1,
      supplierProductId: 0,
      addedLineItempartNumber:0
         
    }

    // const obj = {
    //   position: this.dataSource.length + 1,   // Increment position based on the length of dataSource
    //   id: null,
    //   partNumber: null,
    //   supplierPartNumber: null,
    //   itemDescription: null,
    //   impaId: null,
    //   buyerComment: null,
    //   supplierComment: '',
    //   customsCode: '',
    //   attachments: [],
    //   uom: null,
    //   quantity: 0,
    //   supplierUom: null,
    //   supplierQuantity: 0,
    //   price:0,
    //   discount:null,
    //   totalCost: null,
    //   isActive: true,
    //   isNew: true
    // };


    this.addRow(obj)
    this.dataSource = [...this.dataSource, obj];
    // this.dataSource = lineItemData

    console.log(this.lineItemtableForm.get('rows'),'test 2',this.dataSource)
  }

  get rows(): FormArray {
    return this.lineItemtableForm.get('rows') as FormArray;
  }

  async prefillRfqLineItems() {
   
    if(this.rfqId){

      this.fullLoaderService.showLoader();

      let params = {rfqId:this.rfqId, supplierId:this.userId}
      
      const data = await this.quoteService.fetchRfqLineItemDetailsByRfqToken(params)
      
      if( data &&  data.length > 0){
        
        this.dataSource = []

        const lineItemData = data;
        
        lineItemData.forEach((item: any, index: any) => {
          const obj = {
            position: index + 1,
            id: null,
            partNumber: item.partNumber,
            supplierPartNumber:item.partNo,
            itemDescription: item.itemDescription,
            impaId: item.supplierProductId,
            buyerComment: item.buyerComments,
            supplierComment: '',
            customsCode: '',
            attachments: '',
            uom: item.uom,
            quantity: item.quantity,
            supplierUom:'',
            supplierQuantity:'',
            unitCost: item.unitCost,
            discount: item.discount,
            totalCost: item.price,
            isActive:item.isActive
            
          }

          
  
          this.dataSource.push(obj);

        
      })
     
        
      }
  
      this.populateForm(this.dataSource);
      this.fullLoaderService.hideLoader()
  
       
      }


    


  }
  async fetchRfqDetails(){
      // this.fullLoaderService.showLoader()
      let paramsData = {rfqId:this.rfqId, supplierId:this.userId}
      const data = await this.quoteService.fetchRfqDetailsByRfqToken(paramsData)
      this.headerData = data.rfqData[0]
      this.firstFormGroup.patchValue(
        {
          supplierRfqDetailsId: this.headerData.supplierRfqId
        }
      )
      this.paymentFormGroup.patchValue({
        buyerPaymentTerms:this.headerData.buyerPaymentTerms || null,
      });
      this.fullLoaderService.hideLoader()
  }

  // isValidRequiredFields(): string[] {
  //   const form = this.firstFormGroup;
  //   const missingFields: string[] = [];

  //   // Check each required field and add the missing ones to the array
  //   if (!form.get('incoterms')?.value) {
  //     missingFields.push('Incoterms');
  //   }

  //   // if (!form.get('incotermLocation')?.value?.flag) { // Assuming incotermLocation has a 'flag' property
  //   //   missingFields.push('Incoterm Location');
  //   // }

  //   if (!form.get('incotermLocation')?.value) { // Assuming incotermLocation has a 'flag' property
  //     missingFields.push('Incoterm Location');
  //   }


  //   if (!form.get('quotedDeliveryInDays')?.value) {
  //     missingFields.push('Quoted Delivery In Days');
  //   }

  //   if (!form.get('onTimeDeliveryOrderDate')?.value) {
  //     missingFields.push('On Time Delivery Order Date');
  //   }

  //   if (!form.get('offeredQuality')?.value) {
  //     missingFields.push('Offered Quality');
  //   }

  //   if (!form.get('priceGoodUntilDate')?.value) {
  //     missingFields.push('Price Good Until Date');
  //   }

  //   return missingFields;
  // }

  filterCountries(searchText: string): any[] {
    const filterValue = searchText.toLowerCase();
    return this.countries.filter((country) =>
      country.name.toLowerCase().includes(filterValue)
    );
  }

  onInputChange(searchText: string): void {
    this.filteredCountries = this.filterCountries(searchText);
  }

  isCountrySelected(country: any): boolean {
    return this.selectedCountries.some(selected => selected.id === country.id);
  }

  onCheckboxChange(event: any, country: any): void {
    if (event.checked) {
      // Add the country to the selectedCountries array
      this.selectedCountries.push(country);
    } else {
      // Remove the country from the selectedCountries array
      this.selectedCountries = this.selectedCountries.filter(selected => selected.id !== country.id);
    }
    // Update the form control for incotermLocation with only the country ids
    // this.incotermsFormGroup.get('incotermLocation')?.setValue(this.selectedCountries.map(c => c.id));
    this.firstFormGroup.get('incotermLocation')?.setValue(this.selectedCountries.map(c => c.id));
  }

  getSelectedCountries(): string {
    return this.selectedCountries.map(country => country.name).join(', ');
  }

  async rfqActions(action:string){
    
    if(action == 'download'){
    
    this.fullLoaderService.showLoader()
    
    let fileName = this.headerData?.rfqRefNumber +'.pdf';
    
    let data = {
      supplierId: this.userId,
      rfqId: this.rfqId
    }
    const pdf = await this.SettingsService.generateSupplierRfqAttachmentByRfqToken(data)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()
    }

    else if(action == 'decline'){
      
      this.showDeclineConfirmationDialogue = true

    }

    else if(action == 'acknowledge'){
     
      this.fullLoaderService.showLoader()

      let data = {
        operation:action,
        selectedRfqId : [this.headerData.supplierRfqId]
      }

      await this.SettingsService.rfqOperationsByRfqToken(data)
      this.fullLoaderService.hideLoader()
      this.snack.open('RFQ has been acknowledged', 'OK', {
        duration: 3000,
      });

    }
    this.fetchRfqDetails()
  }

  selectMatTabLink(tabItem:any){
   
    // if(tabItem.route == 'header'){
      
    //     this.back()

    // }

    // else if(tabItem.route == 'payment-terms'){
     
    //   if(this.isSaved){

    //    this.next()

    //   }
    //   else{
    //     this.snack.open(`please save the 'Line item' tab first`, "OK", { duration: 3000 });
    //   }
    // }
    if (tabItem.route == 'header') {

      this.activatedRoute.queryParams.subscribe(async params => {

          if (params['rfqId'] != '' && params['quoteId'] != '') {

            this.rfqId = params['rfqId']
            this.quoteId = params['quoteId']

            this.router.navigate([
              "rfqToken", "quote-header-details"
            ],
              {
                queryParams: { rfqId: this.rfqId, quoteId: this.quoteId }
        
              }
            );

          }

        })
    }else if(tabItem.route == 'line-items'){
      this.activatedRoute.queryParams.subscribe(async params => {

          if (params['rfqId'] != '' && params['quoteId'] != '') {

            this.rfqId = params['rfqId']
            this.quoteId = params['quoteId']

            this.router.navigate([
              "rfqToken", "quote-line-items"
            ],
              {
                queryParams: { rfqId: this.rfqId, quoteId: this.quoteId }
        
              }
            );

          }

        })
    }else if (tabItem.route == 'payment-terms') {

      this.activatedRoute.queryParams.subscribe(async params => {

          if (params['rfqId'] != '' && params['quoteId'] != '') {

            this.rfqId = params['rfqId']
            this.quoteId = params['quoteId']


            this.router.navigate([
              "rfqToken", "quote-payment-terms"
            ],
              {
                queryParams: { rfqId: this.rfqId, quoteId: this.quoteId }
              }
            );

          }

        })
    }
  }

  async checkisTabEnabled() {

    // const data2 = await this.quoteService.getQuoteDraftData('tab1', this.quoteId)

    // if (data2 && data2.length > 0 && Object.keys(data2[0]).length > 0 && data2[0].rfqLineItemDetails.length > 0) {

    //   this.tabEnabled = true

    // }

  }

  async onAddtionalFileSelected(files: NgxFileDropEntry[]) {
    try {

      // this.buyeTtermsDocumentFile = null

      // if (files.length > 1) {
      //   this.snack.open('Please drop only one file at a time.', 'OK', {
      //     duration: 1000,
      //   });
      //   return;
      // }

      // const fileEntry = files[0].fileEntry as FileSystemFileEntry;
      // await new Promise((res, rej) => {
      //   fileEntry.file((file) => {
         
      //     this.buyeTtermsDocumentFile = file;
          
      //     res(file);
      //   });
      // });
    } catch (error: any) {
      this.snack.open(error, 'OK', {
        duration: 1000,
      });
    }
  }

  toggleShowHeaderDetails(event: { checked: boolean }) {
    this.showDetailSection = event.checked;
    // setTimeout(() => {
    //   if (this.table) {
    //     this.table.recalculate();
    //   }
    // }, 100);
  }

  toggleSidebar(value:boolean, section:string,index?:number){

   

    if(section == 'attachment'){
      this.showAddDocumentSection = value
      if(index !== undefined){
        this.selectedLineItemIndex = index
      }
    }
    else if(section == 'cost'){
      this.showAddCostSection = value
    }
    else if(section == 'decline'){
      this.showDeclineSection = value
      if(index !== undefined){
        this.selectedLineItemIndex = index
        
      }
    }
  }

  fileOver(event:any) {
  }
  fileLeave(event:any) {
  }

  async getAllpaymentTerms(){
    this.paymentTermsData = await this.RfqGenerateFormService.getAllpaymentTermsByRfqToken();
    console.log("paymentTermsData",this.paymentTermsData);
  }

  

 

  async toggleBuyerPaymentTermsAndConditionsAttachment(value:boolean){
    this.toggleBlur();
    this.buyerPaymentTermsAndConditionsSection = value;
  }

  async onAttachmentChange(files: NgxFileDropEntry[]) {
    try{


      const rows = this.lineItemtableForm.get('rows') as FormArray;

      if (this.selectedAttachmentType == undefined || this.selectedAttachmentType == null) {

        this.snack.open('Please select the attachment type.', 'OK', {
          duration: 3000,
        });
        return;

      }

      if (this.selectedAttachmentType == 1 || this.selectedAttachmentType == 4) {
 
       
        if (this.hazardousDeclaration == null || this.hazardousDeclaration == undefined) {

          this.snack.open('Hazardous Declaration can not be empty.', 'OK', {
            duration: 3000,
          });

          return;

        }


      }

      this.newfileuploaded = true;
      this.fullLoaderService.showLoader();
     
      if(this.selectedLineItemIndex!=null){
        
        this.uploadedAttachmentsArray = rows.at(this.selectedLineItemIndex).get('attachments')?.value || [];
      
        if (this.uploadedAttachmentsArray.length > 5) {
        
        throw new Error('Maximum 5 files allowed for a product!');
         }

      const fileEntries = files
        .filter((entry) => entry.fileEntry.isFile)
        .map((ele) => ele.fileEntry as FileSystemFileEntry);

        console.log(fileEntries,"fileEntries")

      if (fileEntries.length === 0) {
        throw new Error('Please upload valid files!');
      }
      if (fileEntries.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      await new Promise((res, rej) => {
        fileEntries.map((fileEntry) => {
          fileEntry.file(async(file) => {
            let fileExt = file.name.split('.').pop();
            if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
              // rej('Invalid filetype!');
              return;
            }

            if (file.size > this.maxFileSize) {
              throw new Error('File size must be less than 5MB!')
            }

            let uploadedAttachment:any = {
              lineItemIndex:this.selectedLineItemIndex,
              dataUrl:'',
              name:file.name,
              file:file,
              attachmentType: this.selectedAttachmentType,
              hazardousDeclaration:this.hazardousDeclaration
            }

            await new Promise((res,rej)=>{
              const reader = new FileReader();
              reader.onload = (e: any) => {
                uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
                res(true)
              };
              reader.readAsDataURL(file); // Read the file as a data URL
            })

            this.uploadedAttachmentsArray.push(uploadedAttachment);
            res(file);
          });
        });
      });

      rows.at(this.selectedLineItemIndex).patchValue({
        attachments: this.uploadedAttachmentsArray
              
      });
      console.log( rows.at(this.selectedLineItemIndex).get('attachments')?.value,this.uploadedAttachmentsArray)

      this.fullLoaderService.hideLoader();
    }
  }catch(error:any){
    this.snack.open(error, 'OK', {
      duration: 1000,
    });
  }
  }

  onDeclineReasonChange(event: MatSelectChange){
    
    const selectedValue = event.value;
    
    if(selectedValue=='7'){
      this.showOtherReason = true
    }
    else{
      this.showOtherReason = false
    }
  }


  onAttachmentTypeChange(event: MatSelectChange){
    
    const selectedValue = event.value;
    
    if(selectedValue == 1 || selectedValue == 4){
      this.showHazardousDeclaration = true
    }
    else{
      this.showHazardousDeclaration = false
    }
  }

  toggleWrapDescription(event: MatSlideToggleChange) {
    this.isWrapDescription = event.checked;
  }

  declineLineItem(){
    
  //   const rows = this.lineItemtableForm.get('rows') as FormArray;
  

  //   if(this.declineReason ==undefined || this.declineReason ==null ){
      
  //     this.snack.open('Please select the decline reason.', 'OK', {
  //       duration: 3000,
  //     });
  //     return;
    
  // }

  //     if( this.declineReason == 7 && (this.otherReason == null || this.otherReason == '')){
          
  //       this.snack.open('Other reason can not be empty.', 'OK', {
  //         duration: 3000,
  //       });
        
  //       return;
      
  //   }

  //     const reason = this.delineReasonData.find(item => item.id === this.declineReason);

  //     const reasonDesc = reason ? reason.reasonDescription : 'Reason not found';

  //     if(this.selectedLineItemIndex!=null){
        
  //       rows.at(this.selectedLineItemIndex).patchValue({
  //         isActive: 0,
  //         declineReasonTypeId : this.declineReason,
  //         delineOtherReason: this.otherReason,
  //         declineReasonDescription: reasonDesc,
  //         attachments:[],
  //         supplierQuantity:0
  
  //       });

  //       this.snack.open(`Line Item Declined, selected line item attachments are removed`, "OK", { duration: 3000 });
  //     }
      
      
  //     this.showDeclineSection = false
  //     this.declineReason = null
  //     this.otherReason = ''
  //     this.selectedLineItemIndex = null

      this.calculateCostSummary()
    
  }

  restoreLineitem(index:number){

    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const quantityValue = rows.at(index).get('quantity')?.value;

    rows.at(index).patchValue({
      isActive: 1,
      declineReasonTypeId :null,
      delineOtherReason: null,
      declineReasonDescription: null,
      supplierQuantity:quantityValue || 0

    });

    this.snack.open(`Line Item Restored`, "OK", { duration: 3000 });

  }

  isDecline(index:number){
    
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    // Get the value of the 'isActive' field
    const isActive = row.get('isActive')?.value;
    
    // Return the value (true or false)
    return isActive === 0; 
  }

  getDeclineReason(index:number){
    
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    // Get the value of the 'isActive' field
    const reason = row.get('declineReasonDescription')?.value || '';
    
    return `Declined - ${reason || 'No reason provided'}`;
   
  }

  isNew(index:number){
    
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    const isNew = row.get('isNew')?.value;
    
    // Return the value (true or false)
    return isNew === 1; 
  }

  saveAdditionalCost(){
   

    if(this.freightDescription =='' || this.freightType =='' || this.freightValue ==null ){
      
      this.snack.open('Please fill the additional cost details.', 'OK', {
        duration: 3000,
      });
      return;
    
     } 
      let params = {
        id:null,
        freightDescription: this.freightDescription,
        freightType: this.freightType,
        freightValue: this.freightValue,
        isActive:1
      }
      console.log('params',params);
      this.addedAdditionalCost.push(params)

      this.secondFormGroup.get('quoteLineItemFreight')?.setValue(this.addedAdditionalCost)

      console.log(this.addedAdditionalCost)
      console.log(this.secondFormGroup);
      console.log('test',this.secondFormGroup.get('quoteLineItemFreight')?.value);
      this.calculateCostSummary()

      this.showAddCostSection = false
      this.freightDescription = ''
      this.freightType = ''
      this.freightValue = null
    


  }

  updateSelectedCountriesFromLocationIds(locationIds: number[]): void {
  this.selectedCountries = this.countries
    .filter(country => locationIds.includes(country.id))
    .map(country => ({
      id: country.id,
      name: country.name
    }));
}

  async getQuoteDraftData() {

    this.fullLoaderService.showLoader()

      const data = await this.quoteService.getQuoteDraftDataByRfqToken('tab2', Number(this.quoteId))
      console.log({data});
      if (data && data.length > 0 && Object.keys(data[0]).length > 0 && data[0].quotationLineItems.length > 0) {


        if ( data[0].quotationLineItems[0].quoteLineItemDetailsId) {
          this.isSaved = true
        }

        this.secondFormGroup.patchValue({


          quoteLineItemHeaderId:data[0].quoteLineItemHeaderId || '',
          quoteLineItemListPriceSubtotal:data[0].quoteLineItemListPriceSubtotal || '',
          quoteLineItemDiscount:data[0].quoteLineItemDiscount || '',
          quoteLineItemSubtotal :data[0].quoteLineItemSubtotal || '',
          quoteLineItemGeneralDiscountType :data[0].quoteLineItemGeneralDiscountType || '',
          quoteLineItemGeneralDiscountValue:data[0].quoteLineItemGeneralDiscountValue || '',
          quoteLineItemFreightTotal:data[0].quoteLineItemFreightTotal || '',
          quoteLineItemFreight:data[0].quoteLineItemFreight || [],
          quoteLineItemTotal :data[0].quoteLineItemTotal || '',
          supplierCurrency: data[0].supplierCurrency

         
        });


        this.freightValues = data[0].quoteLineItemFreight || []

        this.supplierCurrencyName = data[0].supplierCurrency?.currencyCode || null;

        console.log("lineitmefreight",this.secondFormGroup.get('quoteLineItemFreight')?.value);

        

        this.dataSource = [];

        if (data[0].quotationLineItems && data[0].quotationLineItems.length > 0) {

          data[0].quotationLineItems.forEach((item: {
            supplierProductId: any;
            isAddedBySupplier: any;
            leadTime: any;
            attachments: any;
            declineReasonTypeId: any;
            declineReasonDescription: any;
            delineOtherReason: any;
            supplierQuantity: any;
            supplierUom: any;
            uom: any;
            customsCode: any;
            buyerComment: any;
            impaId: any;
            supplierPartNumber: any;
            quoteLineItemDetailsId: any;
            isActive: any;
            partNumber: any;itemDescription: any; unitCost: any; discount: any; supplierComment: any;  quantity: any; discountedUnitPrice: any; totalCost: any; 
             }, index: number) => {
              console.log({item});
            const obj = {
              position: index + 1, // Assign position based on index
              id: item.quoteLineItemDetailsId,
              partNumber: item.partNumber,
              supplierPartNumber: item.supplierPartNumber,
              itemDescription: item.itemDescription,
              impaId: item.impaId,
              buyerComment: item.buyerComment,
              supplierComment: item.supplierComment,
              customsCode: item.customsCode,
              uom: item.uom,
              supplierUom: item.supplierUom,
              quantity: item.quantity,
              supplierQuantity: item.supplierQuantity,
              price: item.unitCost,
              discount: item.discount,
              discountedUnitPrice: item.discountedUnitPrice,
              totalCost:item.totalCost,
              isActive: item.isActive,
              declineReasonTypeId: item.declineReasonTypeId,
              delineOtherReason: item.delineOtherReason,
              declineReasonDescription: item.declineReasonDescription,
              attachments:item.attachments,
              leadTime:item.leadTime,
              isNew:0,
              isAddedBySupplier: item.isAddedBySupplier,
              supplierProductId:  item.supplierProductId
              

            };

           console.log({obj})

            this.dataSource.push(obj); // Push each object to dataSource

            console.log("datasource",this.dataSource);

          });

          this.populateForm(this.dataSource);


          // this.toggleSelectAllLineItem(true)


      
        }

        this.fullLoaderService.hideLoader()

      }
      else {
        this.prefillRfqLineItems()
      }

      const data1 = await this.quoteService.getQuoteDraftDataByRfqToken('tab1', this.quoteId);

      console.log("data fetched with getQuoteDraftData", data1);

      if (data1 && data1.length > 0 && Object.keys(data1[0]).length > 0) {
        const buyerAttachments = data1[0].buyerAttachments;

        // Iterate through the buyerAttachments array and push the s3_path into buyerAttachmentUrl
        buyerAttachments.forEach((attachment: any) => {
          if (attachment.s3_path) {
            this.buyerAttachmentUrl.push(attachment.s3_path);
          }
        });

        console.log("buyerAttachmentUrl", this.buyerAttachmentUrl);

        if (data1[0].incoterms) {
          this.firstFormGroup.patchValue({
            incoterms: data1[0].incoterms,
            // incotermLocation: data1[0].incotermLocation,
            incotermLocation: data1[0].incotermLocationsID,
          });
          // Update selectedCountries based on the incotermLocationIds
          
          this.updateSelectedCountriesFromLocationIds(data1[0].incotermLocationsID || []);
        }

        this.firstFormGroup.patchValue({
          // quote details
          quoteId: data1[0].quoteId || null,
          rfqId: data1[0].rfqId || null,
          supplierRfqDetailsId: data1[0].supplierRfqId,
          quoteRefNumber: data1[0].quoteRefNumber || null,
          quoteDate: data1[0].quotationDate || null,
          priceGoodUntilDate: data1[0].pricesGoodUntil || null,
          offeredQuality: data1[0].offeredQuality || null,
          onTimeDeliveryOrderDate: data1[0].onTimeDeliveryOrderBy || null,
          quotedDeliveryInDays: data1[0].quotedDeliveryInDays || null,
          
          // my details
          supplierId: data1[0].supplierId || null,
          supplierContactName: data1[0].supplierContactName || null,
          supplierEmail: data1[0].supplierEmail || null,
          supplierTelephone: data1[0].supplierTelephone || null,
          supplierMobile: data1[0].supplierMobile || null,
          supplierCompanyEmail: data1[0].supplierCompanyEmail || null,
          supplierCurrency: data1[0].supplierCurrency || null,

          // comment
          supplierComment: data1[0].supplierComment || null,
          buyerComment: data1[0].buyerComment || null,
          quoteHeaderAttachmentType: data1[0].quoteHeaderAttachmentType || null,
          quoteHeaderAttachments: data1[0].quoteHeaderAttachments || null,

          // freight forwarder
          quoteFreightForwarderId: data1[0].qffId || null,
          freightForwarderDetailsId: data1[0].qffDetailsId || null,
          freightForwarderCompanyName: data1[0].qffCompanyName || null,
          pic: data1[0].qffpic || null,
          freightForwarderJobTitle: data1[0].qffjobTitle || null,
          freightForwarderEmailId: data1[0].qffemailId || null,
          freightForwarderPhone: data1[0].qffphone || null,
          freightForwarderFax: data1[0].qfffax || null,
          freightForwarderAddress: data1[0].qffaddress || null,
          packaging: data1[0].qffpackaging || null,
          modeOfTransport: data1[0].qffmodeOfTransport || null
        });

        await this.supplierService.getSupplierUpdateDataByUserIdByRfqToken()
          .then((res) => {
            console.log("response of getSupplierUpdateDataByUserId", res.data[0]);
            this.firstFormGroup.patchValue({
              supplierId: Number(data1[0].supplierId),
              supplierContactName: res.data[0].companyName,
              supplierEmail: res.data[0].primaryEmail,
              supplierTelephone: res.data[0].phone1,
              supplierMobile: res.data[0].phone1,
              supplierCompanyEmail: res.data[0].primaryEmail,
              supplierCurrency: res.data[0].supplierCurrency,
            });
            this.paymentTermsAndConditions = res.data[0].paymenttermsconditioncolumn;
            this.paymentTermsAndConditionAttachmentUrl = res.data[0].s3_Path;
          });

        this.uploadedAttachmentsArray = data1[0].quoteHeaderAttachments;
        if (this.uploadedAttachmentsArray && this.uploadedAttachmentsArray.length > 0) {
          this.supplierAttachmentUrls = this.uploadedAttachmentsArray.map(
            (att: any) => att.url || att.dataUrl
          ).filter((url: string) => !!url);
        }
      }


      const data2 = await this.quoteService.getQuoteDraftDataByRfqToken('tab3', this.quoteId);
      console.log({data2});
      if (data2 && data2.length > 0 && Object.keys(data2[0]).length > 0) {

        console.log(data2);

        //added for buttons saveAsDraft and submit implementation
        this.quoteStatus=data2[0].quoteStatus;
        console.log("quoteStatus",this.quoteStatus);

        this.paymentLeadTimeId = data2[0].paymentLeadTimeId;
        this.paymentTermsId = data2[0].paymentTermsId;
        this.paymenttermsconditioncolumn = data2[0].paymenttermsconditioncolumn;
        this.paymentTermsAndConditionAttachmentUrl = data2[0].s3_Path;
        this.buyerCity = data2[0].buyer_city;
        this.buyerStateCode = data2[0].buyer_stateCode;
        this.buyerCountry = data2[0].buyer_country;
        this.buyerStreet = data2[0].buyer_street;
        this.buyerZipCode = data2[0].buyer_zipcode;
        
        const billingAddress = `${this.buyerStreet} ${this.buyerCity}, ${this.buyerStateCode} - ${this.buyerZipCode} ${this.buyerCountry}`;
        
        this.buyerPaymentTermsAndConditionAttachmentUrl = data2[0].buyer_s3_Path;
        // const taxStatusData = JSON.parse(data2[0]?.taxStatus || '[]');
        const taxStatusData = data2[0]?.taxStatus || [];
        console.log({ taxStatusData });
        
        this.paymentFormGroup?.patchValue({
          supplierRfqDetailsId: data2[0].supplierRfqId || null,
          paymentTermsId: data2[0].paymentTermsId || null,
          termsAndConditions: data2[0].termsAndConditions || null,
          currencyInstructions: data2[0].currencyInstructions || null,
          billingAddress: billingAddress,
          buyerTermsAndConditions: data2[0].buyer_paymenttermsconditioncolumn || null,
          // buyerPaymentTerms: data2[0].buyer_paymentLeadTime || null,
          taxStatus: data2[0]?.taxStatus,
        });
        this.buyerId = data2[0].buyerId;
        this.getTaxDetails(this.buyerId)
        
        
        this.buyerFormGroup.patchValue({
          billingAddress: billingAddress,
          buyerTermsAndConditions: data2[0].buyer_paymenttermsconditioncolumn || null,
          // buyerPaymentTerms: data2[0].buyer_paymentLeadTime || null,
          taxStatus:data[0]?.taxStatus,
        });

        this.quoteLineItemApplicableTaxProfile=  [
           
          data[0].supplierTaxtaxProfile,
          data[0].supplierTaxStatusCountry,
          data[0].supplierTaxStatusTaxType,
          data[0].supplierTaxStatusRegion,
          data[0].supplierTaxStatusTaxNumber,
          data[0].supplierTaxtaxPercentage
        ]
        .filter(value => value != null && value !== '') // removes null, undefined, or empty strings
        .join(' - '),
        this.quoteLineItemTaxAmount = data[0].supplierTaxtaxAmount,
        this.quoteLineItemTaxType = data[0].supplierTaxStatusTaxType
       
        console.log("paymentLeadTimeId",this.paymentLeadTimeId);
        console.log(this.buyerFormGroup.get('taxStatus')?.value,this.paymentFormGroup.get('taxStatus')?.value);
      }



      this.fullLoaderService.hideLoader()

  }

  getIncotermCountryControl(): any {
    return this.firstFormGroup.get('incotermLocation') as FormControl;
  }


  onCountrySelected(value: AutoCompleteDataType) {
   
  }


  async downloadDocument(s3_path:string) {
    this.fullLoaderService.showLoader();
    let fileName = s3_path.split("/")[s3_path.split("/").length - 1];
    await this.dataTransferService.downloadFile(s3_path, fileName)
    this.fullLoaderService.hideLoader();
  }

  toggleBlur(): void {
    const element = document.querySelector('.blurry');
    if (element) {
      element.classList.toggle('blur');
    } else {
      console.warn('Element with class "blurry" not found.');
    }
  }

  // isPdf(url: string): boolean {
  //   return url?.toLowerCase().endsWith('.pdf');
  // }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.buyerAttachmentUrl.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.buyerAttachmentUrl.length) %
      this.buyerAttachmentUrl.length;
  }

  nextDocSlide() {
    this.currentDocIndex = (this.currentDocIndex + 1) % this.previewDocs.length;
  }

  prevDocSlide() {
    this.currentDocIndex =
      (this.currentDocIndex - 1 + this.previewDocs.length) %
      this.previewDocs.length;
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true; // For data URLs, check if the MIME type is 'application/pdf'
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf'); // For URLs, check if it ends with '.pdf'
  }

  async toggleHeaderAttachmentImage(value: boolean, url?: any) {
    if(url){
      this.headerAttachmentUrl=url;
    }
    this.toggleBlur();
    this.headerAttachmentSection=value;
  }

  async togglePaymentTermsAndConditionsAttachment(value:boolean){
    this.toggleBlur();
    this.paymentTermsAndConditionsSection = value;
  }
  async toggleBuyerAttachments(value:boolean){
    this.toggleBlur();
    this.buyerAttachmentsSection=value;
  }
  async toggleSupplierAttachments(value:boolean){
    if(value) {
      this.supplierCurrentIndex = 0;
    }
    this.toggleBlur();
    this.supplierAttachmentsSection=value;
  }
  nextSupplierSlide() {
    this.supplierCurrentIndex = (this.supplierCurrentIndex + 1) % this.supplierAttachmentUrls.length;
  }
  prevSupplierSlide() {
    this.supplierCurrentIndex =
      (this.supplierCurrentIndex - 1 + this.supplierAttachmentUrls.length) %
      this.supplierAttachmentUrls.length;
  }
  checkDateClass(date: any): string {
    
    const dateStr = date.toISOString().split('T')[0];  // Format to YYYY-MM-DD
    const etaDateStr = this.headerData?.vesselEta.toISOString().split('T')[0];
    const etdDateStr = this.headerData?.vesselEtd.toISOString().split('T')[0];

    // Check if the date matches the ETA or ETD date and return respective class
    if (dateStr === etaDateStr) {
      return 'eta-date';  // ETA Date (Blue)
    } else if (dateStr === etdDateStr) {
      return 'etd-date';  // ETD Date (Green)
    }
    return '';  // Default case (no class)
  }

  async removeAttachment(attachment: any) {

    // set the isDelete flag in db to true
    if(attachment?.attachmentId){
      
      this.delAttachmentArr.push(attachment.attachmentId)
    }

    // remove from the product array
    
      this.uploadedAttachmentsArray.splice(
        this.uploadedAttachmentsArray.findIndex((ele) => ele.name === attachment.name),
        1
      );

      this.firstFormGroup.get('quoteHeaderAttachments')?.setValue(this.uploadedAttachmentsArray)
      
      console.log(this.uploadedAttachmentsArray,'uploadedAttachmentsArray')
      

    this.cdr.detectChanges()
  }

  async renameAttachment(){}
  
  async saveAttachment(){

    if(this.delAttachmentArr.length > 0){

      this.fullLoaderService.showLoader()
      await this.quoteService.deleteAttachmentByRfqToken(this.delAttachmentArr)
      this.snack.open(`Attachment deleted`, "OK", { duration: 3000 });
      this.fullLoaderService.hideLoader()
    }

    this.showAddDocumentSection = false
  
  }

  cancelDecline(){
    this.showDeclineConfirmationDialogue = false
    this.declineReason = ''
  }

  async declineRfq(){

      this.fullLoaderService.showLoader()
      
      this.showDeclineConfirmationDialogue =true
      let data = {
        declineReason:this.declineReason,
        supplierRfqDetailsId : this.headerData.supplierRfqId
      }

      await this.quoteService.declineRfqByRfqToken(data)
      this.fullLoaderService.hideLoader()
      this.showDeclineConfirmationDialogue = false
      this.snack.open('RFQ has been declined', 'OK', {
        duration: 3000,
      });

      this.fetchRfqDetails()

  }

  getLineItemAttachment(){
   
    const rows = this.lineItemtableForm.value.rows
    
    if(this.selectedLineItemIndex!=null){
      const row = rows[this.selectedLineItemIndex];
      const attachment = row.attachments || []
      // Get the value of the 'isActive' field
       return attachment;
    }
    else{
      return []
    }
   

    
  }

  filterFieldCurrencyNameDisplayFn(_currency: Currency) {
    return _currency ? `${_currency.currencyCode}` : undefined;
  }

  getCurrencyFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    return this.SettingsService.getAllCurrenciesByFliterKeyValueByRfqToken(
      pageMeta.serachParam,
      pageMeta
    );
  }


  getCurrencyControl(): any {
    return this.secondFormGroup.get('supplierCurrency') as FormControl;
  }


  
  onPartNumberSelected(event: any, index:number) {
    console.log(event,'event')
    
    const selectedItem = event

    const rows = this.lineItemtableForm.get('rows') as FormArray;

    rows.at(index).patchValue({
      partNumber:selectedItem.partNo,
      supplierPartNumber:selectedItem.partNo,
      itemDescription:selectedItem.ItemName,
      impaId:selectedItem.impaId,
      supplierProductId: selectedItem.supplierProductId,
      quantity:1,
      isNew: 1,
      isAddedBySupplier :1
      
    });

  }
  // Category autocomplete section
  filterFieldSupplierProductNameDisplayFn(_supplierProduct: AutoCompleteSupplierProduct) {
    return _supplierProduct ? `${_supplierProduct.partNo}` : undefined;
  }

  getSupplierProductFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    console.log('Search Parameter:', pageMeta.serachParam);
    const response = this.SettingsService.getAllAutocompleteSupplierProductByFliterKeyValueAndSupplierIdByRfqToken(
      pageMeta.serachParam,
      this.userId,
      pageMeta,

    );
    console.log('Response Category', response);
    return response;
  }


  getPartNumberControl(index: number): FormControl {
    const rows = this.lineItemtableForm.get('rows') as FormArray;
    const row = rows.at(index) as FormGroup;
    return row.get('addedLineItempartNumber') as FormControl ;
  }

  async togglePreview(value:boolean,section:string,docs?:any){
    this.previewSection=value;
    this.previewDocs = []

      if(section == 'multiple'){
          
        if (docs !== undefined && docs !== null && typeof docs === 'number') {

          const rows = this.lineItemtableForm.value.rows

          const row = rows[docs];
          const attachment = row.attachments || []
          
          console.log(attachment,'attachment')
          this.previewDocs= attachment;
          
         } else {
           this.previewDocs=[]
         }

      }
      else{
        this.previewDocs= []
      }
    
  }

  async getTaxDetails(buyerId:any) {
    this.fullLoaderService.showLoader();
    let data = {
      buyerId: Number(buyerId),
      userType:"buyer"
    };
    const response = await this.BuyerService.getTaxDetailsByRfqToken(data);
    this.taxStatusData = response.rows;
    console.log(this.taxStatusData)
    this.fullLoaderService.hideLoader();
  }

 
  async fetchExchangeRates(baseCurrency: string, supplierCurrency: string) {
    try {
      // Check if exchange rates are already cached
      if (!this.exchangeRatesCache[baseCurrency]) {
        const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
        
        const res: any = await this.http.get(url).toPromise();
  
        if (res.result === 'success') {
          this.exchangeRatesCache[baseCurrency] = res.conversion_rates;
          console.log('Exchange rates fetched successfully:', res.conversion_rates);
        } else {
          console.error('API error:', res['error-type']);
          return;
        }
      }
  
      // After fetching the exchange rates, apply conversion to all rows
      this.applyConversionToAllRows(baseCurrency, supplierCurrency);
    } catch (error) {
      console.error('Error fetching exchange rates:', error);
      this.snack.open('Error fetching exchange rates', 'Close', { duration: 4000 });
    }
  }

  applyConversionToAllRows(baseCurrency: string, supplierCurrency: string) {
    const convert_rows = this.lineItemtableForm.get('rows') as FormArray;
  
    // Loop through all rows and apply conversion
    for (let i = 0; i < convert_rows.length; i++) {
      const row = convert_rows.at(i); // Get the row FormGroup at index i
      
      const supplierUnitCost = row.get('unitCost')?.value || 0;
      const supplierTotalCost = row.get('totalCost')?.value || 0;
  
      console.log(baseCurrency, supplierCurrency, supplierUnitCost, supplierTotalCost, 'supplierAmount');
  
      // Apply conversion to UnitCost
      const convertedUnitCost = this.convertAmount(supplierUnitCost, baseCurrency, supplierCurrency);
      this.applyConversionToUnitCost(row, convertedUnitCost);
  
      // Apply conversion to TotalCost
      const convertedTotalCost = this.convertAmount(supplierTotalCost, baseCurrency, supplierCurrency);
      this.applyConversionToTotalCost(row, convertedTotalCost);
    }
  }
  
  convertAmount(supplierAmount: number, baseCurrency: string, supplierCurrency: string) {
    const rates = this.exchangeRatesCache[baseCurrency];
    if (rates && rates[supplierCurrency]) {
      const conversionRate = rates[supplierCurrency];
      return (supplierAmount * conversionRate).toFixed(2); // Convert and format to 2 decimal places
    } else {
      this.snack.open('Conversion rate not available', 'Close', { duration: 4000 });
      return '0.00'; // Return 0 if conversion rate not found
    }
  }
  
  applyConversionToUnitCost(row: any, convertedAmount: string) {
    // Assuming you're using reactive forms
    row.get('convertedUnitCost')?.setValue(convertedAmount); 
    console.log('Converted UnitCost:', convertedAmount);
  }
  
  applyConversionToTotalCost(row: any, convertedAmount: string) {
    // Assuming you're using reactive forms
    row.get('convertedTotalCost')?.setValue(convertedAmount); 
    console.log('Converted TotalCost:', convertedAmount);
  }




  
}
